const $ = jQuery

export default function ttmZeroCircle () {
  const sections = document.querySelectorAll('.mtt-ttmzero-circle')

  if (sections.length) {
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i]

      addAnimationClass(section)

      window.addEventListener('scroll', () => {
        addAnimationClass(section)
      })
    }
  }
}

function addAnimationClass (section) {
  if (inViewport(section)) {
    if (!section.classList.contains('start-animation')) {
      section.classList.add('start-animation')
    }
  }
}

function inViewport (el) {
  if (!el) return false

  const BOUNDING = el.getBoundingClientRect()

  if (
    BOUNDING.top + (BOUNDING.height / 2) > 0 &&
    BOUNDING.left + (BOUNDING.width / 2) > 0 &&
    BOUNDING.top + (BOUNDING.height / 2) < (window.innerHeight || document.documentElement.clientHeight) &&
    BOUNDING.left + (BOUNDING.width / 2) < (window.innerWidth || document.documentElement.clientWidth)
  ) {
    return true
  }

  return false
}
